"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FixedRegexNode = void 0;
const BaseNode_1 = require("../../BaseNode");
const Schema = __importStar(require("./schema.json"));
const NODE_TYPE = 'FIXED-REGEX';
class FixedRegexNode extends BaseNode_1.BaseNode {
    constructor() {
        super(...arguments);
        this._resolve = (params) => {
            const { regex, text } = params;
            const outputRecord = { match: false, result: [] };
            if (regex && text && text.toString) {
                // build regex object from passed in expression
                // check for match
                try {
                    const regExObject = new RegExp(regex);
                    const textToCheck = text.toString();
                    const results = textToCheck.match(regExObject);
                    if (results) {
                        for (const result of results) {
                            outputRecord.result.push(result);
                        }
                        outputRecord.match = true;
                        //if match, put any available groups on the output
                        for (let i = 1; i < results.length && i <= 5; i++) {
                            const key = `group${i}`;
                            outputRecord[key] = results[i];
                        }
                    }
                }
                catch (e) {
                    // if we fail, return false
                }
            }
            return outputRecord;
        };
        //TODO: Build the interface definition from the given schema....but what is our schema
        this._interfaceDefinition = Schema;
    }
}
exports.FixedRegexNode = FixedRegexNode;
FixedRegexNode._nodeDefinition = {
    NODE_TYPE,
    defaultTitle: 'Regular Expression',
    isIdempotent: true,
    primaryCategory: 'Comparison',
};
//# sourceMappingURL=FixedRegEx.js.map